<span>
    {{ ("ALARM_ROUTE" | translate) + " " }}

    <a [routerLink]="['/staff', $safeNavigationMigration(log?.details?.targetId)]" (click)="closeDialog.emit()">
        {{ $safeNavigationMigration(log?.details?.targetName) | identityFormat : $safeNavigationMigration(log?.details?.targetId) }}
    </a>

    {{ " " + ("WAS_MODIFIED_BY" | translate) + " " }}

    <strong *ngIf="!log?.staffId && log?.staffName === 'Everon Admin';else elseBlock">
        Everon Admin
    </strong>

    <ng-template #elseBlock>
        <a [routerLink]="['/staff', $safeNavigationMigration(log?.staffId)]" (click)="closeDialog.emit()">{{ $safeNavigationMigration(log?.staffName) | identityFormat :
            $safeNavigationMigration(log?.staffId) }}</a>
    </ng-template>
</span>
<p class="mt-1">{{ $safeNavigationMigration(log?.timestamp) | moment : "l LTS" }}</p>

<hr />
<div class="alarm-route-container">
    <!-- Alarm route name -->
    <ng-container *ngIf="visibleFields | includes : 'name'">
        <span class="item-title">{{ "ALARM_ROUTE_NAME" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.name?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.name?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Location name -->
    <ng-container *ngIf="visibleFields | includes : 'locationName'">
        <span class="item-title">{{ "LOCATION" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.locationName?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.locationName?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

       <!-- Priority -->
       <ng-container *ngIf="visibleFields | includes : 'priority'">
        <span class="item-title">{{ "PRIORITY" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ (alarmRouteChanges?.priority?.oldValue ? ('PRIORITY_' + alarmRouteChanges.priority.oldValue) : 'NONE') | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ (alarmRouteChanges?.priority?.newValue ? ('PRIORITY_' + alarmRouteChanges.priority.newValue) : 'NONE') | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Delivery type -->
    <ng-container *ngIf="visibleFields | includes : 'deliveryType'">
        <span class="item-title">{{ "DELIVERY_TYPE" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.deliveryType?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.deliveryType?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Call loop fail type -->
    <ng-container *ngIf="visibleFields | includes : 'callLoopFailType'">
        <span class="item-title">{{ "CALL_LOOP_FAIL_TYPE" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.callLoopFailType?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.callLoopFailType?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Call center name -->
    <ng-container *ngIf="visibleFields | includes : 'callCenterName'">
        <span class="item-title">{{ "CALL_CENTER" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.callCenterName?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.callCenterName?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Call center delivery type -->
    <ng-container *ngIf="visibleFields | includes : 'callCenterDeliveryType'">
        <span class="item-title">{{ "CALL_CENTER_DELIVERYTYPE" | translate }}:</span>
        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ oldCallCenterDeliveryType || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ newCallCenterDeliveryType || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Fallback delivery type -->
    <ng-container *ngIf="visibleFields | includes : 'fallbackType'">
        <span class="item-title">{{ "FALLBACK_DELIVERY_TYPE" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.fallbackType?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.fallbackType?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Fallback Call center -->
    <ng-container *ngIf="visibleFields | includes : 'fallbackCallCenter'">
        <span class="item-title">{{ "FALLBACK_CALL_CENTER" | translate }}:</span>

        <div class="alarm-item-pair-value">
            <span class="negative-highlight line-through">
                {{ alarmRouteChanges?.fallbackCallCenter?.oldValue || "NONE" | translate }}
            </span>
            <i class="fa-light fa-arrow-right-long fa-lg"></i>
            <span class="positive-highlight">
                {{ alarmRouteChanges?.fallbackCallCenter?.newValue || "NONE" | translate }}
            </span>
        </div>
    </ng-container>

    <!-- Skip inactive teams for assistance -->
    <ng-container *ngIf="visibleFields | includes : 'skipInactiveTeamsForAssistance'">
        <span class="item-title">{{ "SKIP_INACTIVE_TEAMS_FOR_ASSISTANCE" | translate }}:</span>
        <div class="alarm-item-value">
            <ng-container *ngIf="alarmRouteChanges.skipInactiveTeamsForAssistance else disabled">
                <span class="positive-highlight">
                    {{ "ENABLED" | translate }}
                </span>
            </ng-container>
            <ng-template #disabled>
                <span class="negative-highlight">
                    {{ "DISABLED" | translate }}
                </span>
            </ng-template>
        </div>
    </ng-container>

    <!-- Alarm indication group enabled -->
    <ng-container *ngIf="visibleFields | includes : 'alarmIndicationGroupEnabled'">
        <span class="item-title">{{ "ALARM_INDICATION_GROUP" | translate }}:</span>
        <div class="alarm-item-value">
            <ng-container *ngIf="alarmRouteChanges.alarmIndicationGroupEnabled else disabled">
                <span class="positive-highlight">
                    {{ "ENABLED" | translate }}
                </span>
            </ng-container>
            <ng-template #disabled>
                <span class="negative-highlight">
                    {{ "DISABLED" | translate }}
                </span>
            </ng-template>
        </div>
    </ng-container>

    <!-- Wait for SMS Acknowledgement -->
    <ng-container *ngIf="visibleFields | includes : 'waitForSmsAcknowledgement'">
        <span class="item-title">{{ "WAIT_FOR_SMS_ACKNOWLEDGEMENT" | translate }}:</span>
        <div class="alarm-item-value">
            <ng-container *ngIf="alarmRouteChanges.waitForSmsAcknowledgement else disabled">
                <span class="positive-highlight">
                    {{ "ENABLED" | translate }}
                </span>
            </ng-container>
            <ng-template #disabled>
                <span class="negative-highlight">
                    {{ "DISABLED" | translate }}
                </span>
            </ng-template>
        </div>
    </ng-container>

    <!-- Devices -->
    <ng-container *ngIf="visibleFields | some : 'addedDevices' : 'removedDevices'">
        <span class="item-title">{{ "DEVICES" | translate }}:</span>
        <div class="details-box">

            <!-- Added Devices -->
            <ng-container *ngIf="visibleFields | includes : 'addedDevices'">
                <span class="item-value d-flex align-items-baseline">
                    {{ "ADDED" | translate }}:
                    <ng-container *ngIf="alarmRouteChanges?.addedDevices?.length">
                        <div class="device-list">
                            <div class="positive-highlight mt-1 mb-1 ml-2 d-inline-block"
                                *ngFor="let device of $safeNavigationMigration(alarmRouteChanges?.addedDevices) | slice:0:getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedDevices), $safeNavigationMigration(alarmRouteChanges?.removedDevices)).visibleAdded">
                                <span>{{ device.name || device.id }}</span>
                                <span *ngIf="device.alertTypes?.length">
                                    : {{ getTranslatedAlertTypes(device) }}
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </span>
            </ng-container>

            <div></div>

            <!-- Removed Devices -->
            <ng-container *ngIf="visibleFields | includes : 'removedDevices'">
                <span class="item-value d-flex align-items-baseline">
                    {{ "REMOVED" | translate }}:
                    <ng-container *ngIf="alarmRouteChanges?.removedDevices?.length">
                        <div class="device-list">
                            <div class="negative-highlight line-through mt-1 mb-1 ml-2 d-inline-block"
                                *ngFor="let device of $safeNavigationMigration(alarmRouteChanges?.removedDevices) | slice:0:getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedDevices), $safeNavigationMigration(alarmRouteChanges?.removedDevices)).visibleRemoved">
                                <span>{{ device.name || device.id }}</span>
                                <span *ngIf="device.alertTypes?.length">
                                    : {{ getTranslatedAlertTypes(device) }}
                                </span>
                            </div>
                        </div>
                    </ng-container>
                </span>
            </ng-container>

            <!-- Hidden count if there are more items -->
            <ng-container
                *ngIf="getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedDevices), $safeNavigationMigration(alarmRouteChanges?.removedDevices)).hiddenCount > 0">
                <div class="mt-4"></div>
                <span class="more-count">
                    +{{ getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedDevices), $safeNavigationMigration(alarmRouteChanges?.removedDevices)).hiddenCount
                    }}
                    {{ " MORE" | translate }} </span>
            </ng-container>
        </div>

    </ng-container>


    <!-- Recipients -->
    <ng-container *ngIf="visibleFields | some : 'addedRecipients' : 'removedRecipients'">
        <span class="item-title">{{ "RECIPIENTS" | translate }}:</span>
        <div class="details-box">

            <!-- Added Recipients -->
            <ng-container *ngIf="visibleFields | includes : 'addedRecipients'">
                <span class="item-value d-flex align-items-baseline">
                    {{ "ADDED" | translate }}:
                    <ng-container *ngIf="alarmRouteChanges?.addedRecipients?.length">
                        <div class="device-list">
                            <div class="positive-highlight mt-1 mb-1 ml-2 d-inline-block"
                                *ngFor="let recipient of $safeNavigationMigration(alarmRouteChanges?.addedRecipients) | slice:0:getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedRecipients), $safeNavigationMigration(alarmRouteChanges?.removedRecipients)).visibleAdded">
                                <span>{{ recipient.name }} ( {{ recipient.id }} )</span>
                            </div>
                        </div>
                    </ng-container>
                </span>
            </ng-container>

            <div></div>

            <!-- Removed Recipients -->
            <ng-container *ngIf="visibleFields | includes : 'removedRecipients'">
                <span class="item-value d-flex align-items-baseline">
                    {{ "REMOVED" | translate }}:
                    <ng-container *ngIf="alarmRouteChanges?.removedRecipients?.length">
                        <div class="device-list">
                            <div class="negative-highlight line-through mt-1 mb-1 ml-2 d-inline-block"
                                *ngFor="let recipient of $safeNavigationMigration(alarmRouteChanges?.removedRecipients) | slice:0:getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedRecipients), $safeNavigationMigration(alarmRouteChanges?.removedRecipients)).visibleRemoved">
                                <span>{{ recipient?.name }} ( {{ recipient?.id }} )</span>
                            </div>
                        </div>
                    </ng-container>
                </span>
            </ng-container>

            <!-- Hidden count if there are more items -->
            <ng-container
                *ngIf="getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedRecipients), $safeNavigationMigration(alarmRouteChanges?.removedRecipients)).hiddenCount > 0">
                <div class="mt-4"></div>
                <span class="more-count">
                    +{{ getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedRecipients),
                    $safeNavigationMigration(alarmRouteChanges?.removedRecipients)).hiddenCount
                    }}
                    {{ " MORE" | translate }} </span>
            </ng-container>
        </div>
    </ng-container>

    <!-- Service times -->
    <ng-container *ngIf="visibleFields | some : 'removedServiceTimes' : 'addedServiceTimes'">
        <span class="item-title">{{ "SCHEDULE" | translate }}:</span>
        <div class="details-box">
            <ng-container *ngFor="let scheduleGroup of getOrderedSchedules(alarmRouteChanges)">
                <div *ngIf="scheduleGroup.removed.length || scheduleGroup.added.length"
                    class="d-flex align-items-center">
                    <div class="schedule-row">
                        <ng-container *ngIf="scheduleGroup.removed.length">
                            <span class="negative-highlight line-through ml-2">
                                <ng-container *ngFor="let schedule of scheduleGroup.removed; let last = last">
                                    {{ scheduleGroup.day | dayOfWeek | translate }}: {{ schedule.startTime?.slice(0, 5)
                                    }} - {{
                                    schedule.endTime?.slice(0, 5) }}
                                    <span *ngIf="!last">, </span>
                                </ng-container>
                            </span>
                        </ng-container>

                        <span *ngIf="scheduleGroup.removed.length && scheduleGroup.added.length" class="mx-2"><i
                                class="fa-light fa-arrow-right-long fa-lg"></i></span>

                        <ng-container *ngIf="scheduleGroup.added.length">
                            <span class="positive-highlight ml-2">
                                <ng-container *ngFor="let schedule of scheduleGroup.added; let last = last">
                                    {{ scheduleGroup.day | dayOfWeek | translate }}: {{ schedule.startTime?.slice(0, 5)
                                    }} - {{ schedule.endTime?.slice(0, 5) }}
                                    <span *ngIf="!last">, </span>
                                </ng-container>
                            </span>
                        </ng-container>

                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <!-- Fallback route recipients -->
    <ng-container *ngIf="visibleFields | some : 'addedFallBackRecipients' : 'removedFallBackRecipients'">
        <span class="item-title">{{ "FALLBACK_RECIPIENTS" | translate }}:</span>
        <div class="details-box">

            <!-- Added FallBack Recipients -->
            <ng-container *ngIf="visibleFields | includes : 'addedFallBackRecipients'">
                <span class="item-value d-flex align-items-baseline">
                    <ng-container *ngIf="alarmRouteChanges?.addedFallBackRecipients?.length">
                        {{ "ADDED" | translate }}:
                        <div class="device-list">
                            <div class="positive-highlight mt-1 mb-1 ml-2 d-inline-block"
                                *ngFor="let recipient of $safeNavigationMigration(alarmRouteChanges?.addedFallBackRecipients) | slice:0:getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedFallBackRecipients), $safeNavigationMigration(alarmRouteChanges?.removedFallBackRecipients)).visibleAdded">
                                <span>{{ recipient.name }} ( {{ recipient.id }} )</span>
                            </div>
                        </div>
                    </ng-container>
                </span>
            </ng-container>

            <div></div>

            <!-- Removed FallBack Recipients -->
            <ng-container *ngIf="visibleFields | includes : 'removedFallBackRecipients'">
                <span class="item-value d-flex align-items-baseline">
                    <ng-container *ngIf="alarmRouteChanges?.removedFallBackRecipients?.length">
                        {{ "REMOVED" | translate }}:
                        <div class="device-list">
                            <div class="negative-highlight line-through mt-1 mb-1 ml-2 d-inline-block"
                                *ngFor="let recipient of $safeNavigationMigration(alarmRouteChanges?.removedFallBackRecipients) | slice:0:getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedFallBackRecipients), $safeNavigationMigration(alarmRouteChanges?.removedFallBackRecipients)).visibleRemoved">
                                <span>{{ recipient?.name }} ( {{ recipient?.id }} )</span>
                            </div>
                        </div>
                    </ng-container>
                </span>
            </ng-container>

            <!-- Hidden count if there are more items -->
            <ng-container
                *ngIf="getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedFallBackRecipients), $safeNavigationMigration(alarmRouteChanges?.removedFallBackRecipients)).hiddenCount > 0">
                <div class="mt-4"></div>
                <span class="more-count">
                    +{{ getVisibleItems($safeNavigationMigration(alarmRouteChanges?.addedFallBackRecipients),
                    $safeNavigationMigration(alarmRouteChanges?.removedFallBackRecipients)).hiddenCount
                    }}
                    {{ " MORE" | translate }} </span>
            </ng-container>
        </div>
    </ng-container>

</div>